export const environment = {
  apiUrl: 'https://staging.homesi.fullstackagency.it/api/v1',
  applicationId: 'f9c4e832-8a63-5d97-b847-2f5e9d7b0a16',
  redirectUrl: 'https://staging.homesi.fullstackagency.it/callback',
  meilisearch: 'https://meilisearch.staging.homesi.fullstackagency.it',
  meilisearchKey: '4ooEMV2sMpLm4wXMCgnexDifTDFmJx8yvE9PwiCh',
};
